<template>
  <div>

    <h4 class="section-title">Cadastro</h4>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="account-name">Nome</label>
          <input v-model="account.name" id="account-name" type="text" class="form-control">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="account-responsible">Nome do responsável</label>
          <input v-model="account.responsible_name" id="account-responsible" type="text" class="form-control">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="account-phone">Telefone</label>
          <input v-model="account.phone" id="account-phone" type="text"
                 class="form-control" v-mask="'(##) #### #####'">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="account-address">Endereço</label>
          <input v-model="account.address" id="account-address" type="text" class="form-control">
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>UF</label>
          <StatesSelect v-model="account.uf" class="form-control"/>
        </div>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label>Cidade</label>
          <CitySelect v-model="account.city_code" :code-uf="account.uf" class="form-control"/>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="account-business-area">Área de negócio</label>
          <input v-model="account.business_area" id="account-business-area" type="text" class="form-control">
        </div>
      </div>
    </div>

    <h4 class="section-title tags-title">
      Tags

      <AccountTagsPopover :tags="tags"
                          :tagIds="linkedIds"
                          @associateTags="$emit('associate-tags', $event)"
                          @changeTags="$emit('reload-tags')"
                          @deletedTag="$emit('reload-tags')"/>
    </h4>

    <p class="tab-hint">
      A tag vale para a conta inteira e é a mesma da listagem de contas. Vincular e desvincular
      grava na hora, fora do Salvar da tela.
    </p>

    <div v-if="linked.length" class="tags-cell">
      <span v-for="tag in linked" :key="tag.id" class="tag-badge"
            :style="{ backgroundColor: `#${tag.color}`, color: tagTextColor(tag.color) }">
        {{ tag.name }}
      </span>
    </div>

    <p v-else class="empty">Nenhuma tag vinculada a esta conta.</p>

  </div>
</template>

<script>
  import { mask } from 'vue-the-mask'

  import AccountTagsPopover from '@/components/admin/accounts/AccountTagsPopover'
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import StatesSelect from '@/components/shares/specialTag/StatesSelect.vue'
  import { tagTextColor } from '@/utils/accountTags'

  export default {
    components: { AccountTagsPopover, CitySelect, StatesSelect },
    computed: {
      linked() {
        return this.account.tags || []
      },
      linkedIds() {
        return this.linked.map(tag => tag.id)
      }
    },
    directives: { mask },
    methods: { tagTextColor },
    name: 'TabGeneral',
    props: {
      account: { required: true, type: Object },
      tags: { default: () => [], type: Array }
    }
  }
</script>

<style scoped>
  .section-title {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .tags-title {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid var(--border-color);
  }

  .tab-hint {
    margin-bottom: 16px;
    font-size: 13px;
    color: var(--secondary-text-color);
  }

  .tags-cell {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
  }

  .tag-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.2;
  }

  .empty {
    font-size: 13px;
    color: var(--secondary-text-color);
  }
</style>
